import { Inject, Injectable } from "@angular/core";
import { ANGULARJS_TRANSLATE } from "@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers";
import { DwdmDiagramAbstractConverterEnd } from "../../diagram/converter/dwdm-diagram-abstract-converter-end";
import { DwdmDiagramConverterMuxService } from "../../diagram/converter/dwdm-diagram-converter-mux.service";
import { EndConverterData, EndpointElementIdentifier } from "../../diagram/converter/dwdm-diagram-converter.models";
import { DwdmDiagramWizardConverterAmplifiersService } from "./dwdm-diagram-wizard-converter-amplifiers.service";
import { DwdmDiagramWizardConverterOscsService } from "./dwdm-diagram-wizard-converter-oscs.service";
import { DwdmDiagramWizardConverterTranspondersService } from "./dwdm-diagram-wizard-converter-transponders.service";

/**
 * Implementação da @see DwdmDiagramAbstractConverterEnd para a wizard de criação de circuitos DWDM.
 */
@Injectable({
    providedIn: "root"
})
export class DwdmDiagramWizardConverterEndService extends DwdmDiagramAbstractConverterEnd {

    constructor(@Inject(ANGULARJS_TRANSLATE) translate: any,
            private readonly muxConverterService: DwdmDiagramConverterMuxService,
            private readonly transpondersConverterService: DwdmDiagramWizardConverterTranspondersService,
            private readonly amplifiersConverterService: DwdmDiagramWizardConverterAmplifiersService,
            private readonly oscsConverterService: DwdmDiagramWizardConverterOscsService) {
        super(translate);
    }

    public convert(endConverterData: EndConverterData): EndpointElementIdentifier {
        return this.convertData(endConverterData, {
            transponders: (data) => this.transpondersConverterService.convert(data),
            mux: (data) => this.muxConverterService.convert(data),
            amplifiers: (data) => this.amplifiersConverterService.convert(data),
            oscs: (data) => this.oscsConverterService.convertForEnd(data)
        });
    }
}
